import { useMemo } from 'react'
import useAuthStore from 'store/auth'

const GetUrls = () => {
  const user = useAuthStore((state) => state.user);
  const programId = user?.programId;

  const baseUrl = process.env.REACT_APP_API_HOST || 'https://kupidapi.tr4ns.com';
  const thorHost =
    process.env.REACT_APP_API_THOR_HOST || 'https://kupid-pos.tr4ns.com';

  return useMemo(() => {
    const createUrl = (path: string, includesProgramId: boolean = true) =>
      `${baseUrl}${path}${includesProgramId ? `/${programId}` : ''}`;

    const createThorUrl = (path: string, includeProgramId: boolean = true) =>
      `${thorHost}${path}${includeProgramId ? `/${programId}` : ''}`;

    return {
      getReceiptFormat: (traderId: string) => createUrl(`/receiptDetail/${programId}/${traderId}`, false),
      getUser: (traderId: string) => createUrl(`/user/getbyprogramid?programId=${programId}&traderId=${traderId}`, false),
      getProduct: (traderId: string) => createUrl(`/product/getbyprogram/${programId}/${traderId}`, false),
      layout: (traderId: string) =>  createUrl(`/layout/${programId}/${traderId}`, false),
      getReceipt: (params: string) => createUrl(`/saleTransaction?programId=${programId}&${params}`, false),
      getDailySalesReport: createThorUrl('/report/daily-sales-report', false),
      postLayout: createUrl('/layout', false),
      getButtonStyle: createUrl('/buttonStyle/getbyprogram'),
      postButtonStyle: createUrl('/buttonStyle', false),
      getDenominations: createUrl('/denominations'),
      postDenominations: createUrl('/denominations', false),
      productLayout: createUrl('/layout/product?layoutId=', false),
      getPaymentType: createUrl('/paymentType'),
      postPaymentType: createUrl('/paymentType', false),
      paymentTypeDetail: createUrl('/paymentTypeDetail', false),
      paymentTypes: createUrl('/paymentTypes', false),
      getPriceLevel: createUrl('/priceLevel/getbyprogram'),
      postPriceLevel: createUrl('/priceLevel', false),
      productDetails: createUrl('/productDetails', false),
      getProductPriceLevel: createUrl('/productpriceLevel', false),
      postProductPriceLevel: createUrl('/productpriceLevel', false),
      productTax: createUrl('/productTax', false),
      productTaxType: createUrl('/productTaxType', false),
      programDetail: createUrl('/programDetail', false),
      getTax: createUrl('/tax'),
      postTax: createUrl('/tax', false),
      postUser: createUrl('/user', false),
      postChangeUserPassword: createUrl('/user/changepassword', false),
      getUserType: createUrl('/userType'),
      postUserType: createUrl('/userType', false),
      updateReceiptFormat: createUrl('/receiptDetail/', false),
      postProduct: createUrl('/product', false),
      getClass: createUrl('/class/getbyprogram'),
      postClass: createUrl('/class', false),
      getSubclass: createUrl('/subClass/getbyprogram'),
      postSubclass: createUrl('/subClass', false),
      
      /** THOR API **/ 
      getDepartment: createThorUrl('/departments'),
      postDepartment: `${thorHost}/departments/insert`,
      updateDepartment: `${thorHost}/departments/update`,
      
      postProductAlt: createThorUrl('/products'),
      updateProductAlt: createThorUrl('/products'),
      // postProductAlt: `${thorHost}/products/insert`,
      // updateProductAlt: `${thorHost}/products/update`,

      postClassAlt: `${thorHost}/classes/insert`,
      updateClassAlt: `${thorHost}/classes/update`,
      
      postSubclassAlt: `${thorHost}/subclasses/insert`,
      updateSubclassAlt: `${thorHost}/subclasses/update`,
      
      getCategory: createThorUrl('/categories'),
      postCategory: `${thorHost}/categories/insert`,
      updateCategory: `${thorHost}/categories/update`,
      
      getSubcategory: createThorUrl('/subcategories'),
      postSubcategory: `${thorHost}/categories/insert`,
      updateSubcategory: `${thorHost}/categories/update`,
    }
  }, [baseUrl, thorHost, programId])
}

export default GetUrls;